/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/ 
import * as i0 from "./chips-list.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./chips-list.component";
var styles_ChipsListComponent = [i0.styles];
var RenderType_ChipsListComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ChipsListComponent, data: {} });
export { RenderType_ChipsListComponent as RenderType_ChipsListComponent };
export function View_ChipsListComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_ChipsListComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 2, "app-chips-list", [], null, null, null, View_ChipsListComponent_0, RenderType_ChipsListComponent)), i1.ɵdid(1, 4374528, null, 1, i2.ChipsListComponent, [], null, null), i1.ɵqud(603979776, 1, { chips: 1 })], null, null); }
var ChipsListComponentNgFactory = i1.ɵccf("app-chips-list", i2.ChipsListComponent, View_ChipsListComponent_Host_0, {}, {}, ["*"]);
export { ChipsListComponentNgFactory as ChipsListComponentNgFactory };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/chips/chips-list/chips-list.component.ngfactory.js.pre-build-optimizer.js